import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { Card, CardBody, CardHeader, Button, Row, Col } from 'reactstrap';
import { kebabCase } from 'lodash';
import SaveButton from '../controls/saveButton';
import Icon from './icon';
import ReportTagsButton from '../controls/reportTagsButton';
import FavoriteButton from '../../favorites/favoriteButton';
const SectionPanel = ({
  onNavButtonClick: _onNavButtonClick = false,
  navButtonTitle: _navButtonTitle = '',
  onBack: _onBack = false,
  backButtonTitle: _backButtonTitle = '',
  name: _name = '',
  children: _children = [],
  centerText: _centerText = true,
  isSaveDisabled: _isSaveDisabled = false,
  isNavButtonVisible: _isNavButtonVisible = true,
  isPending: _isPending = false,
  showSave: _showSave = true,
  showTagButton: _showTagButton = false,
  showFavoriteButton: _showFavoriteButton = false,
  onSave
}) => {
  let saveState = SaveButton.STATUS_DISABLED;
  if (_isPending && !_isSaveDisabled) {
    saveState = SaveButton.STATUS_PENDING;
  } else if (_isPending && _isSaveDisabled) {
    saveState = SaveButton.STATUS_IN_PROGRESS;
  }
  const classes = classnames({
    'text-center': _centerText
  });
  const bbTitle = _backButtonTitle ? ` ${_backButtonTitle}` : 'Back';
  const backButtonGlyphs = bbTitle ? null : /*#__PURE__*/React.createElement(Icon, {
    glyph: "arrow-left"
  });
  const rightOptionalButtonCount = (_showTagButton ? 1 : 0) + (_showFavoriteButton ? 1 : 0);
  let titleColumnWidth = 8 - rightOptionalButtonCount;
  const rightButtonColumnWidth = 2 + rightOptionalButtonCount;
  let leftButtonColumnWidth = 2;
  if (_onBack && _onNavButtonClick && _isNavButtonVisible) {
    titleColumnWidth -= 1;
    leftButtonColumnWidth = 3;
  }
  return /*#__PURE__*/React.createElement(Card, {
    className: "t-section-panel"
  }, /*#__PURE__*/React.createElement(CardHeader, {
    className: "card-heading"
  }, /*#__PURE__*/React.createElement("div", {
    className: classes
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    sm: leftButtonColumnWidth
  }, _onBack ? /*#__PURE__*/React.createElement(Button, {
    className: "float-md-left t-button-back",
    size: "sm",
    onClick: _onBack
  }, backButtonGlyphs, bbTitle) : undefined, _onNavButtonClick && _isNavButtonVisible ? /*#__PURE__*/React.createElement(Button, {
    className: "t-button-nb",
    size: "sm",
    onClick: _onNavButtonClick
  }, _navButtonTitle) : undefined), /*#__PURE__*/React.createElement(Col, {
    sm: titleColumnWidth
  }, /*#__PURE__*/React.createElement("h3", {
    "data-testid": "t-sp-title",
    className: `t-sp-title t-sp-title-${kebabCase(_name)}`
  }, _name)), /*#__PURE__*/React.createElement(Col, {
    sm: rightButtonColumnWidth
  }, _showFavoriteButton ? /*#__PURE__*/React.createElement(FavoriteButton, null) : undefined, _showTagButton ? /*#__PURE__*/React.createElement(ReportTagsButton, {
    reduxEntity: "report"
  }) : undefined, _showSave ? /*#__PURE__*/React.createElement(SaveButton, {
    onSave: onSave,
    saveState: saveState
  }) : undefined)))), /*#__PURE__*/React.createElement(CardBody, null, _children));
};
SectionPanel.propTypes = {
  centerText: PropTypes.bool,
  isPending: PropTypes.bool,
  isSaveDisabled: PropTypes.bool,
  isNavButtonVisible: PropTypes.bool,
  onNavButtonClick: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  navButtonTitle: PropTypes.string,
  onBack: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  backButtonTitle: PropTypes.string,
  onSave: PropTypes.func.isRequired,
  showSave: PropTypes.bool,
  showTagButton: PropTypes.bool,
  showFavoriteButton: PropTypes.bool,
  name: PropTypes.string,
  children: PropTypes.node
};
export default SectionPanel;